/* HoM Haute · The Muses: each muse lives inside their own room (vibe illustration backdrop) */
(function(){
var C='https://cdn.shopify.com/s/files/1/0994/9475/6664/files/vibe-',V={
kemal:'kemal-soemadipradja.jpg?v=1793505533',gendhis:'gendhis-larasati.jpg?v=1793505542',tasha:'tasha-liem.jpg?v=1793505551',
ketut:'ketut-mahendra.jpg?v=1793505543',margriet:'margriet-latumahina.jpg?v=1793505551',galuh:'galuh-ramadhani.jpg?v=1793505543',
bonar:'bonar-hutapea.jpg?v=1793505543',tenri:'andi-tenriola.jpg?v=1793505542',elias:'elias-rumbiak.jpg?v=1793505542',
joost:'joost-verhoeven.jpg?v=1793505542',mariam:'mariam-al-kaabi.jpg?v=1793505551',ren:'ren-takeda.jpg?v=1793505551',
marcus:'marcus-bell.jpg?v=1793505551',isla:'isla-brennan.jpg?v=1793505542',youssef:'youssef-bennani.jpg?v=1793505551',
yuchen:'lin-yu-chen.jpg?v=1793505551',caio:'caio-nogueira.jpg?v=1793505543',lorenzo:'lorenzo-maffei.jpg?v=1793505551'};
var SL={};
function slugs(){((window.HM&&HM.all)||[]).forEach(function(m){if(!m||!m.id)return;var s=m.slug||m.img||'';s=s.replace(/^.*\/files\//,'').replace(/-portrait\.png.*$/,'');if(s)SL[m.id]=s;});}
function u(k,w){if(V[k])return C+V[k]+'&width='+w;return 'https://cdn.shopify.com/s/files/1/0994/9475/6664/files/'+SL[k]+'-vibe.jpg?width='+w;}
function run(){
 slugs();var w=window.innerWidth<760?900:1800;
 document.querySelectorAll('#hm section.muse').forEach(function(s){
  var k=s.id.replace('hm-','');if(!V[k]&&!SL[k])return;
  if(!s.querySelector(':scope>.vbg')){
   var d=document.createElement('div');d.className='vbg';d.setAttribute('aria-hidden','true');
   var i=document.createElement('i');i.style.backgroundImage='url("'+u(k,w)+'")';d.appendChild(i);
   s.insertBefore(d,s.firstChild);s.classList.add('has-vibe');
  }
  s.querySelectorAll('.pn.vb img').forEach(function(im){var n=u(k,1200);if(im.src!==n){im.removeAttribute('srcset');im.src=n;im.classList.remove('x');}});
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
window.addEventListener('load',run);setTimeout(run,1500);
})();
